import styled from 'styled-components';
import CloseIcon from 'components/CloseIcon';

export const Item = styled.div`
    width: 100%;
    height: 71px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 10px;
    background: linear-gradient(210.55deg, #353A40 -3.02%, #121416 93.08%);
    box-shadow: 36px 12px 64px rgba(2, 3, 3, 0.7), -12px -20px 56px rgba(232, 237, 243, 0.05), inset -16px -6px 80px rgba(248, 249, 249, 0.03);
    border-radius: 10px;
    overflow-y: hidden;
    margin-top: 20px;
    @media only screen and (max-width: 768px) {
        font-size: 15px;
        height: 55px;
    }
`;

export const Title = styled.div`
    font-family: Khula;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 100%;
    /* identical to box height, or 20px */

    display: flex;
    align-items: center;
    color: #D6E1EF;

    @media only screen and (max-width: 768px) {
        font-size: 15px;
    }
`;

export const Price = styled.div`
    margin-left: auto;
    font-family: Khula;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 100%;
    display: flex;
    align-items: center;
    text-align: right;
    color: #D6E1EF;
    @media only screen and (max-width: 768px) {
        font-size: 15px;
    }
`;

export const CloseButton = styled(CloseIcon)`
    cursor: pointer;
    
`;

export const CloseButtonContainer = styled.div`
    cursor: pointer;
    margin: 0px 10px 10px 20px;
`;